<template>
  <div>
    <div class="swiper-container">
      <div class="swiper-wrapper" ref="swiper-container">
        <div
          class="swiper-slide"
          v-for="(item, index) in imglistone"
          :key="index"
        >
          <b-img fluid :src="item.img"></b-img>
        </div>
        <!-- <div class="swiper-slide">
                <b-img fluid :src="imgs"  style="height: 33.5rem;width:100%"></b-img>
              </div> -->
      </div>
    </div>
    <b-container fulid class="pc-swiper2">
      <b-row>
        <!-- <b-col cols="12" sm="12" md="12" lg="12" xl="12"> -->
        <div class="swiper2">
          <span class="title">电梯全品类配件，用户一键触达</span>
          <div class="swiper-containertwo">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in imglist"
                :key="index"
              >
                <div>
                  <b-img :src="item.img" style="width: 70px" fluid></b-img>
                  <p class="pp">{{ item.name }}</p>
                </div>
              </div>
            </div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div></div
      ></b-row>
    </b-container>
  </div>
</template>
<script>
import Swiper from "swiper";
import request from "../../../utils/request";
export default {
  name: "swipers",
  data() {
    return {
      url: "",
      img_1: require("../../../stater/6_2.jpg"),
      img_2: require("../../../stater/news_index.png"),
      img_3: require("../../../stater/6.png"),
      imgs: require("../../../stater/cc.jpg"),
      imglistone: [],
      imglist: [],
    };
  },
  mounted() {
    if (location.hostname == "localhost") {
      this.url = "https://gys.yitipei.com/";
    } else {
      this.url = location.origin;
    }
    this.list();
  },
  methods: {
    list() {
      request({
        url: "/gys/index/config",
        method: "get",
        params: {},
      })
        .then((res) => {
          this.imglist = res.data.category.map((i) => {
            i.img = this.url + i.img;
            return i;
          });
          this.imglistone = res.data.rollImage.map((i) => {
            i.img = this.url + i.img;
            return i;
          });
          let slidesPerView = 8;
          console.log(document.body.clientWidth);
          if (document.body.clientWidth < 490) {
            slidesPerView = 5;
          } else if (document.body.clientWidth < 590) {
            slidesPerView = 5;
          } else if (document.body.clientWidth < 690) {
            slidesPerView = 6;
          }
          console.log(slidesPerView);
          this.$nextTick(() => {
            new Swiper(".swiper-containertwo", {
              slidesPerView: slidesPerView,
              spaceBetween: 20,
              centeredSlides: false,
              loop: true,
              loopAdditionalSlides: 3,
              // autoplay: 1000,//时间 毫秒
              autoplayDisableOnInteraction: false,
              speed: 1000,
              autoplayPauseOnMouseover: true,
              prevButton: ".swiper-button-prev",
              nextButton: ".swiper-button-next",
            });
            new Swiper(".swiper-container", {
              slidesPerView: 1,
              spaceBetween: 0,
              centeredSlides: true,
              loop: true,
              loopAdditionalSlides: 1,
              autoplay: 1000, //时间 毫秒
              autoplayDisableOnInteraction: false,
              speed: 1000,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style  scoped>
.pc-swiper2 {
  margin-bottom: 9px;
  padding: 0px;
  width: 70%;
}
@media screen and (max-width: 990px) {
  .pc-swiper2 {
    width: 90%;
  }

  .swiper-container {
    /* display: none; */
  }
  .swiper2 .title {
    display: none;
  }
  .swiper2 .pp {
    display: none;
  }
  .swiper-containertwo {
    height: 3rem !important;
  }
  .swiper2 {
    height: 3rem !important;
    /* padding-top: 1rem; */
    margin-top: -3rem !important;
  }
  .swiper2 .swiper-slide {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .swiper-button-prev,
  .swiper-button-next {
    /* display: none; */
    margin-top: -10px !important;
    width: 23px !important;
    height: 23px !important;
  }
  .swiper-button-prev {
    margin-left: 0rem !important;
  }
  .swiper-button-next {
    margin-right: 0rem !important;
  }
}
.swiper-container {
  --swiper-theme-color: #ff6600;
  --swiper-pagination-color: #00ff33;
  width: 100%;
  height: 100%;
}
.swiper-containertwo {
  width: 79%;
  margin: 0 auto;
  height: 7rem;
  overflow: hidden;
}
.swiper-slide {
  /* height: 33.5rem; */
  overflow: hidden;
}
.swiper-slide img {
  width: 100%;
}
.title {
  padding: 0 22px;
  line-height: 43px;
  color: #fff;
  font-size: 12px;
}
.swiper2 {
  height: 9rem;
  background-color: #134cdea1;
  width: 95%;
  margin: 0 auto;
  margin-top: -9.5rem;
  border-radius: 32px 32px 0 0;
  z-index: 1000;
  position: relative;
}
.swiper-button-prev {
  width: 38px;
  height: 38px;
  background-image: url(../../../stater/mijian.png);
  background-size: 100% 100%;
  margin-left: 2.5rem;
  margin-top: -10px;
}
.swiper-button-next {
  width: 38px;
  height: 38px;
  background-image: url(../../../stater/mijian2.png);
  background-size: 100% 100%;
  margin-right: 2.5rem;
  margin-top: -10px;
}
.pp {
  font-size: 12px;
  color: #fff;
}
@media screen and (max-width: 1200px) {
  .swiper-button-next {
    margin-right: 2rem;
  }
  .swiper-button-prev {
    margin-left: 2rem;
  }
}
</style>